import { STALLABLE_STATUSES, STALLED_AFTER_DAYS } from "./constants";
import type { ProjectLidarUploadStatus } from "./schemas";

const DAY_MS = 24 * 60 * 60 * 1000;

export function stalledDays(
  projectStatus: ProjectLidarUploadStatus,
  now: Date
): number | null {
  if (
    !STALLABLE_STATUSES.includes(projectStatus.status) ||
    !projectStatus.status_reached_at
  ) {
    return null;
  }
  const elapsedDays = Math.floor(
    (now.getTime() - new Date(projectStatus.status_reached_at).getTime()) /
      DAY_MS
  );
  return elapsedDays >= STALLED_AFTER_DAYS ? elapsedDays : null;
}
